module.exports = __webpack_public_path__ + "img/chevron-left-thin.6d3e19dd.svg";